import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/calendar.svg'


const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "formContainer" }
const _hoisted_3 = {
  width: "180",
  filter: "createdOn",
  sort: "createdOn",
  filterType: "date"
}
const _hoisted_4 = {
  filter: "providerName",
  sort: "providerName"
}
const _hoisted_5 = {
  filter: "providerName",
  sort: "providerName"
}
const _hoisted_6 = {
  filter: "garments",
  sort: "garments"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { colspan: "10" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_11 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Your providers",
        text: "Your providers",
        class: "mb-0"
      }),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "btn btn-tertiary",
            to: "/edit-provider/0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_localized_text, {
                localizedKey: "New provider",
                text: "New provider"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_op_table, {
        class: "table table-striped",
        items: _ctx.providers
      }, {
        default: _withCtx((opData) => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Created on",
                  text: "Created on"
                })
              ]),
              _createElementVNode("td", _hoisted_4, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Name",
                  text: "Name"
                })
              ]),
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Country",
                  text: "Country"
                })
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Garments",
                  text: "Garments"
                })
              ]),
              _hoisted_7
            ])
          ]),
          _createElementVNode("tbody", null, [
            (opData.data.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _createElementVNode("td", _hoisted_9, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.ProviderListInfoVM[]), (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "DD.MM.YYYY")), 1),
                _createElementVNode("td", null, _toDisplayString(item.providerName), 1),
                _createElementVNode("td", null, [
                  (item.countryName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createTextVNode(_toDisplayString(item.countryName) + " ", 1),
                        (item.countryRisk)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                              _createTextVNode("- "),
                              _createElementVNode("span", {
                                class: _normalizeClass(["countryRisk", item.countryRisk])
                              }, _toDisplayString(item.countryRisk), 3)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "--"))
                ]),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...new Set(item.garments)], (garment, index) => {
                    return (_openBlock(), _createElementBlock("span", null, [
                      _createTextVNode(_toDisplayString(garment) + " ", 1),
                      (index < [...new Set(item.garments)].length - 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, ", "))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                ]),
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary ms-1",
                    onClick: ($event: any) => (_ctx.$router.push('/edit-provider/' + item.providerIdentifier))
                  }, [
                    (this.isReadOnly)
                      ? (_openBlock(), _createBlock(_component_localized_text, {
                          key: 0,
                          localizedKey: "Provider Detail",
                          text: "Provider Detail"
                        }))
                      : (_openBlock(), _createBlock(_component_localized_text, {
                          key: 1,
                          localizedKey: "Edit Provider",
                          text: "Edit Provider"
                        }))
                  ], 8, _hoisted_15),
                  (!this.isReadOnly)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary ms-1",
                        onClick: ($event: any) => (_ctx.deleteProvider(item.providerIdentifier))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Delete",
                          text: "Delete"
                        })
                      ], 8, _hoisted_16))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _createVNode(_component_router_link, {
      class: "btn btn-secondary withBorder fixedBottomRight",
      to: "/provider-certification-calendar"
    }, {
      default: _withCtx(() => [
        _hoisted_17
      ]),
      _: 1
    })
  ], 64))
}